import { useUser } from '@/hooks/useUser'
import { Settings } from 'lucide-react'
import { Link } from 'react-router-dom'

export function Navbar() {
  const {userInfo} = useUser()
  return (
    <header className="bg-white border-b p-4 flex justify-between items-center">
      <ul className='flex flex-row gap-6'>
      <li className=' text-black'><Link to='/upload'>Upload</Link></li>
        <li className=' text-black'><Link to='/assign-users-report'>Assign</Link></li>
      </ul>
      <div className="flex items-center space-x-4">
        <span className="text-forest">{userInfo?.email} ({userInfo?.role})</span>
          <Settings className="h-5 w-5" />
      </div>
    </header>
  )
}